import { React, useContext } from "react";
import { PageContext } from "../../App";
import { isValidUrl } from "../Utils";

function QRCodeResultView() {
  //get context
  const { scanResult, setScanResult } = useContext(PageContext);

  return (
    <div className="position-relative container text-center">
      {/* Clear button */}
      <button
        className={`position-absolute btn btn-outline-danger rounded-3 ${
          scanResult.result.length === 0 ? "d-none" : ""
        }`}
        style={{ top: "-10px", right: "0px" }}
        onClick={(e) => {
          //clear list
          setScanResult({ ...scanResult, result: [] });
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-x-lg"
          viewBox="0 0 16 16"
        >
          <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
        </svg>
      </button>
      {/* result */}
      <div
        className={`bg-light rounded-2 mt-5 py-5 text-center`}
        style={{ height: "200px", maxHeight: "300px", overflow: "auto" }}
      >
        {/* Print no record */}
        {scanResult.result.length === 0 && (
          <label className="text-dark fs-3 mt-4">No record found</label>
        )}
        {/* Print result */}
        {scanResult.result.length > 0 &&
          scanResult.result.map((codes, index0) =>
            codes.map((item, index1) => (
              <div>
                <label className="fs-6" key={`${index0}_${index1}`}>
                  Format: {item.format} <span className="ms-4"></span>
                  <span
                    style={{
                      width: "100%",
                      height: "auto",
                      cursor: isValidUrl(item.rawValue) ? "pointer" : "auto",
                    }}
                    className={`fs-3 ms-3 ${
                      isValidUrl(item.rawValue)
                        ? "text-primary text-decoration-underline"
                        : "text-dark"
                    }}`}
                    onClick={(e) => {
                      //check
                      if (isValidUrl(item.rawValue)) {
                        //open url
                        var win = window.open(item.rawValue, "_blank");
                        win.focus();
                      }
                    }}
                  >
                    {item.rawValue}
                  </span>
                </label>
              </div>
            ))
          )}
      </div>
    </div>
  );
}

export default QRCodeResultView;
